"use client";
import { Typography } from "@mui/material";
import { Trans } from "@lingui/react/macro";
import React from "react";
import Link from "@/components/core/localized-link";

interface AddToCartSuccessMessageProps {
  item: {
    name: string;
    id?: number;
    subtitle?: string;
    type?: string;
    original_image?: string;
    seo_url?: string;
    price?: number;
    seo_urls?: object;
    special?: number;
    edited?: boolean;
    product_id?: string;
    product_seo_url?: string;
    thumb?: string;
    model?: string;
    stock?: string;
  };
}

const AddToCartSuccessMessage: React.FC<AddToCartSuccessMessageProps> = ({ item }) => {
  return item.edited ? (
    <Trans>
      Success: You have edited
      <Link href={`/product/${item.seo_url}`} data-testid="alert-product" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {item.name}
        </Typography>
      </Link>
      to your
      <Link href="/checkout" data-testid="alert-cart" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          shopping cart
        </Typography>
      </Link>
      !
    </Trans>
  ) : (
    <Trans>
      Success: You have added
      <Link href={`/product/${item.seo_url}`} data-testid="alert-product" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {item.name}
        </Typography>
      </Link>
      to your
      <Link href="/checkout" data-testid="alert-cart" prefetch={false}>
        <Typography
          component="span"
          sx={{
            px: "4px",
            fontSize: "14px",
            color: "primary.main",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          shopping cart
        </Typography>
      </Link>
      !
    </Trans>
  );
};

export default AddToCartSuccessMessage;
